// Ratings.jsx

import React from 'react';

const Ratings = ({ rating }) => {
  const renderStars = () => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    const stars = [];

    for (let i = 0; i < fullStars; i++) {
      stars.push(<span key={i}>&#9733;</span>); // Full star character
    }

    if (hasHalfStar) {
      stars.push(<span key="half" className="half-star">&#9734;&#9733;</span>); // Half star character
    }

    const remainingStars = 5 - stars.length;

    for (let i = 0; i < remainingStars; i++) {
      stars.push(<span key={`empty-${i}`}>&#9734;</span>); // Empty star character
    }

    return stars;
  };

  return (
    <div className="ratings text-warning fs-2 mb-2">
      {renderStars()}
    </div>
  );
};

export default Ratings;
